import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { GraduationCap, Clock, FileQuestion, Award, Lock, Megaphone } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function AnnouncementBar({ items }) {
  if (!items.length) return null;
  const content = items.map((a) => a.text).join("      ✦      ");
  return (
    <div data-testid="announcement-bar" className="nd-marquee flex items-stretch overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md">
      <div className="flex items-center gap-2 px-4 shrink-0 bg-black/15 font-bold text-sm">
        <Megaphone className="w-4 h-4" /> Duyuru
      </div>
      <div className="relative flex-1 overflow-hidden py-2.5">
        <div className="nd-marquee-track">
          <span className="px-6 text-sm font-medium">{content}</span>
          <span className="px-6 text-sm font-medium" aria-hidden="true">{content}</span>
        </div>
      </div>
    </div>
  );
}

export default function Exams() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    api.get("/exams").then(({ data }) => setExams(data));
    api.get("/announcements").then(({ data }) => setAnnouncements(data)).catch(() => {});
  }, []);

  const open = (e) => {
    if (!user?.is_subscribed) { navigate("/abonelik"); return; }
    navigate(`/denemeler/${e.id}`);
  };

  return (
    <div className="space-y-6">
      <AnnouncementBar items={announcements} />
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">🎓 Deneme Sınavları</h1>
        <p className="text-slate-500 mt-1">Gerçek KKTC Kolej soruları ve AI benzer sorularla kendini dene.</p>
      </div>

      {exams.length === 0 && (
        <div className="bg-white border border-dashed border-slate-300 rounded-2xl p-12 text-center">
          <FileQuestion className="w-12 h-12 text-slate-300 mx-auto" />
          <p className="mt-3 text-slate-500 font-semibold">Henüz deneme sınavı eklenmemiş.</p>
          <p className="text-sm text-slate-400">Yakında yeni denemeler burada olacak!</p>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {exams.map((e, i) => (
          <button key={e.id} data-testid={`exam-card-${e.id}`} onClick={() => open(e)}
            className="text-left bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all animate-float-up"
            style={{ animationDelay: `${i * 60}ms` }}>
            <div className="flex items-start justify-between">
              <div className="bg-emerald-500 w-12 h-12 rounded-2xl flex items-center justify-center text-white">
                <GraduationCap className="w-6 h-6" />
              </div>
              {!user?.is_subscribed && <Lock className="w-4 h-4 text-slate-300" />}
              {e.best_score != null && (
                <span className="flex items-center gap-1 bg-amber-50 text-amber-700 text-xs font-bold px-2 py-1 rounded-full">
                  <Award className="w-3 h-3" /> %{e.best_score}
                </span>
              )}
            </div>
            <h3 className="mt-3 font-bold text-lg text-slate-900">{e.title}</h3>
            {e.description && <p className="text-sm text-slate-500 mt-1">{e.description}</p>}
            <div className="mt-4 flex items-center gap-4 text-xs text-slate-500 font-medium">
              <span className="flex items-center gap-1"><FileQuestion className="w-4 h-4" /> {e.question_count} soru</span>
              <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {e.duration_min} dk</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
